import revive_payload_client_4sVQNw7RlN from "/opt/buildhome/repo/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/opt/buildhome/repo/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_9gMxCtyFUG from "/opt/buildhome/repo/node_modules/nuxt-site-config/dist/runtime/plugins/0.siteConfig.mjs";
import check_outdated_build_client_8vK7RkfGxZ from "/opt/buildhome/repo/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import components_plugin_KR1HBZs4kY from "/opt/buildhome/repo/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import composition_sLxaNGmlSL from "/opt/buildhome/repo/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/opt/buildhome/repo/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import unocss_MzCDxu9LMj from "/opt/buildhome/repo/.nuxt/unocss.mjs";
import formkitPlugin_pZqjah0RUG from "/opt/buildhome/repo/.nuxt/formkitPlugin.mjs";
import plugin_BEnDUEy4ze from "/opt/buildhome/repo/node_modules/nuxt-unhead/dist/runtime/plugin.mjs";
import i18n_Fspu1Dj02B from "/opt/buildhome/repo/node_modules/nuxt-site-config/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/opt/buildhome/repo/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import icons_sncVX745v6 from "/opt/buildhome/repo/plugins/icons.ts";
import vercel_client_xTjjRKhane from "/opt/buildhome/repo/plugins/vercel.client.ts";
import vuetify_7h9QAQEssH from "/opt/buildhome/repo/plugins/vuetify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_9gMxCtyFUG,
  check_outdated_build_client_8vK7RkfGxZ,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  unocss_MzCDxu9LMj,
  formkitPlugin_pZqjah0RUG,
  plugin_BEnDUEy4ze,
  i18n_Fspu1Dj02B,
  chunk_reload_client_UciE0i6zes,
  icons_sncVX745v6,
  vercel_client_xTjjRKhane,
  vuetify_7h9QAQEssH
]